"use strict";
// Interface helpers
Object.defineProperty(exports, "__esModule", { value: true });
var shrinkData = function (data) {
    if (data.length > 83) {
        return data.slice(0, 40) + '...' + data.slice(-40);
    }
    return data;
};
var shrinkAddress = function (addr) {
    if (addr.length < 14) {
        return addr;
    }
    return addr.slice(0, 6) + '...' + addr.slice(-4);
};
var interfaceUtils = {
    shrinkData: shrinkData,
    shrinkAddress: shrinkAddress
};
exports.default = interfaceUtils;
